
import {
  INIT_ROLE_PERMISSION_INFO,

  REQUEST_ROLE_PERMISSION_START,
  REQUEST_ROLE_PERMISSION_SUCCESS,
  REQUEST_ROLE_PERMISSION_FAIL,

  SET_ROLE_PERMISSION_START,
  SET_ROLE_PERMISSION_SUCCESS,
  SET_ROLE_PERMISSION_FAIL,

} from '../actions/role-permission';

export const initialState = { error: null, type: INIT_ROLE_PERMISSION_INFO, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {
    case REQUEST_ROLE_PERMISSION_START:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_ROLE_PERMISSION_SUCCESS:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { permission_info: payload.res, isLoading: false, type } }
      }

    case REQUEST_ROLE_PERMISSION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case SET_ROLE_PERMISSION_START:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }
      }

    case SET_ROLE_PERMISSION_SUCCESS:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case SET_ROLE_PERMISSION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_ROLE_PERMISSION_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
